import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../../components/Modal";
import messages from "../../../../../assets/locale/messages";
import { useExpenseForm } from "./useExpenseForm";

const AddEditExpenseModal = ({
  open,
  onClose,
  title,
  handleAddExpense,
  handleEditExpense,
  mode,
  selectedExpense,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const isLoading = useSelector((state) => state.loader);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { shared, mimarProfit } = messages[lang];
  const { renderFormContent, handleSubmit, dirty, isValid, handleResetForm } =
    useExpenseForm(
      mode,
      selectedExpense,
      handleAddExpense,
      handleEditExpense,
      mimarProfit,
      lang
    );

  // Close modal and reset state when submission completes (loader stops)
  useEffect(() => {
    if (!isLoading && isSubmitting) {
      setIsSubmitting(false);
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSubmitting]);

  // Reset form when modal closes
  useEffect(() => {
    if (!open) {
      handleResetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Handle modal close
  const handleClose = () => {
    if (isSubmitting || isLoading) return;
    onClose();
  };

  // Submit handler - prevents duplicate submissions
  const handleSubmitModal = async (e) => {
    if (isSubmitting || isLoading || !dirty) return;

    setIsSubmitting(true);
    handleSubmit(e);
  };

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title={title}
      contentClass="mb-5 pb-2 text-primary"
      content={renderFormContent()}
      isContentText={false}
      confirmBtnTxt={shared.save}
      maxWidth="sm"
      cancelBtnTxt={shared.cancel}
      handleConfirm={handleSubmitModal}
      handleCancel={handleClose}
      modalClass="delete-categories-modal"
      actionsClass="container px-4"
      confirmBtnClass="btn-secondary fsize-14 text-white py-2"
      cancelBtnClass="fsize-14 py-2"
      disableActionBtn={!isValid || isSubmitting || isLoading || !dirty}
      disableBackdropClick={isSubmitting || isLoading}
      disableEscapeKeyDown={isSubmitting || isLoading}
    />
  );
};
export default AddEditExpenseModal;
